"use strict";

jQuery( function ($) {


    // load favorite articles list ===============================================================
    if ($('[data-load-favorite-posts-target]').length) {
        $.ajax({
            url: themevars.ajaxurl,
            data: {
                action: 'get_saved_articles',
            },
            type: 'POST',
            dataType: 'json'
        }).done(function (result) {
            // redirect if user is not logged in
            if (!result.data.logged_in) {
                window.location.replace(window.location.protocol + '//' + window.location.hostname + '/?rmg_dologin=start');
            }

            // if not logged_in show not logged in text
            if($('[data-load-favorite-posts]').length && !result.data.logged_in) {
                $('[data-load-favorite-posts]').addClass('d-none');
            }

            if(result.data.logged_in) {
                // if the user has no favorite articles yet, show the no articles text
                if (undefined === result.data.favorite_articles || result.data.no_favorites_found) {
                    $('[data-load-favorite-posts-noresults]').removeClass('d-none').addClass('d-block');
                    $('[data-load-favorite-posts-target]').addClass('d-none');
                } else {  
                    // add the articles to the target element                      
                    $('[data-load-favorite-posts-target]').append(result.data.favorite_articles);
                    $( document ).trigger( "wpgu-set-favorites-selected" );
                }
            }

            if (true !== result.success) {
                return;
            }
        });
    }
});